import * as React from "react";
import { observer } from "mobx-react";
import { ListItemText, List, Typography, Box } from "@mui/material";
import { VisibilityIcon } from "../../../icons";
import { IconButton } from "@mui/material";

export type ShowReferenceSetProps = {
  selectedValues: { displayId: string; id: string }[];
  label?: string;
  showLabel?: boolean;
  onView?: (id: string) => void;
  hidden?: boolean;
};

export const ShowReferenceSet: React.FC<ShowReferenceSetProps> = observer(
  ({ selectedValues, label, showLabel = true, onView, hidden = false }) => {
    if (hidden) return null;
    const items = selectedValues.map((x, index) => {
      return (
        <div key={index} style={{ display: "flex" }}>
          <ListItemText primary={x.displayId} />
          {onView && (
            <IconButton
              onClick={() => onView(x.id)}
              sx={{ m: 0, p: 0, color: "text.secondary" }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      );
    });
    return (
      <Box sx={{ ml: 2 }}>
        {showLabel && <Typography variant={"caption"}>{label}</Typography>}
        <List>{items}</List>
      </Box>
    );
  }
);
